// enum с перечислениями статусов по лоту
export enum TradeStatus {
    New = 1,
    Draft = 47,
    Approved = 32,
    Declined = 33,
    AllowAcceptance = 34,
    WaitingForTrade = 35,
    Trading = 36,
    Traded = 37,
    Completed = 38,
    StopedByOrganizer = 39,
    WaitingForConfirmation = 40,
    ApplicationProcessing = 41,
    TradeAbandoned = 42,
    LotTradeStatus = 43,
    DeclinedByOrganizer = 44,
    WaitingForStartAllowAcceptance = 45,
    WaitingDecision = 46, // Ожидает решения после обработки заявок (1 заявка)
    WaitingDecisionAfterTrade = 48, // Ожидает решения после торгов (1 ставка)
    Draft2 = 101
}

export var TradeStatusDescription: { [key: TradeStatus]: string; } = {};
TradeStatusDescription[TradeStatus.New] = 'Новый';
TradeStatusDescription[TradeStatus.Draft] = 'Черновик';
TradeStatusDescription[TradeStatus.Approved] = 'Подтверждён';
TradeStatusDescription[TradeStatus.Declined] = 'Отклонён';
TradeStatusDescription[TradeStatus.AllowAcceptance] = 'Приём заявок';
TradeStatusDescription[TradeStatus.WaitingForTrade] = 'Ожидание начала торга';
TradeStatusDescription[TradeStatus.Trading] = 'Торг идёт';
TradeStatusDescription[TradeStatus.Traded] = 'Торг завершён';
TradeStatusDescription[TradeStatus.Completed] = 'Завершён';
TradeStatusDescription[TradeStatus.StopedByOrganizer] = 'Приостановлен';
TradeStatusDescription[TradeStatus.WaitingForConfirmation] = 'Ожидает подтверждения';
TradeStatusDescription[TradeStatus.ApplicationProcessing] = 'Обработка заявок';
TradeStatusDescription[TradeStatus.TradeAbandoned] = 'Торг не состоялся';
TradeStatusDescription[TradeStatus.WaitingForStartAllowAcceptance] = 'Ожидает начала приёма завок';
TradeStatusDescription[TradeStatus.WaitingDecision] = 'Ожидает рассмотрения после приёма заявок';
TradeStatusDescription[TradeStatus.DeclinedByOrganizer] = 'Отменён организатором';
TradeStatusDescription[TradeStatus.WaitingDecisionAfterTrade] = "Ожидает рассмотрения после торгов";
